import dynamic from 'next/dynamic';

const PartnerCard = dynamic(import('@/components/partner/card.js'));
const Select = dynamic(import('@/core/select.js'));
const SelectBlack = dynamic(import('@/core/select-black.js'));
const DropDown = dynamic(import('@/core/dropdown.js'));
const SpaceCardSkinHome = dynamic(import('@/components/space/card-skin-home.js'));
const SpaceCardSkinCities = dynamic(import('@/components/space/card-skin-cities.js'));
const SpaceCardSkinCorpo = dynamic(import('@/components/space/card-skin-corpo.js'));

const Input = dynamic(import('@/core/input'), { ssr: false });
const Button = dynamic(import('@/core/button'));
const Search = dynamic(import('@/core/search'));
const YesNo = dynamic(import('@/core/yesno'));
const HeaderConfirm = dynamic(import('@/components/header/login/corpo/corpoConfirm'));
const HeaderCorpo = dynamic(import('@/components/header/login/corpo/corpo'));
const HeaderLoginCorpo = dynamic(import('@/components/header/login/corpo/index.js'));
const HeaderRegisterCompany = dynamic(import('@/components/header/login/corpo/registerCompany'));
const HeaderLogin = dynamic(import('@/components/header/login'));
const HeaderSignup = dynamic(import('@/components/header/signup'));
const HeaderSignupStep2 = dynamic(import('@/components/header/signupstep2'));
const LayoutCard = dynamic(import('@/components/corpo/layoutCard'));
const HeaderHelp = dynamic(import('@/components/header/help.js'));
const HeaderBookmark = dynamic(import('@/components/header/bookmark.js'));
const PartnerResume = dynamic(import('@/components/partner/resume'));
const BreadcrumCms = dynamic(import('@/components/breadcrum/cms'));
const SpaceSimulator = dynamic(import('@/components/simulator/space'));
const HomeZonePlus = dynamic(import('@/components/home/zonePlus'));
const HomeZoneSpacesPartners = dynamic(import('@/components/home/zoneSpacesPartners'));
const ActivitiesCard = dynamic(import('@/components/corpo/activitiesCard'));
const ProfileCard = dynamic(import('@/components/corpo/profileCard'));
const ParamsCard = dynamic(import('@/components/corpo/paramsCard'));
const TeamCard = dynamic(import('@/components/corpo/teamCard'));
const HomeZoneSpacesCities = dynamic(import('@/components/home/zoneSpacesCities'));

const SearchRiders = dynamic(import('@/components/fields/riders'), { ssr: false });
const SearchLoading = dynamic(import('@/components/search/search-loading'));
const SearchMap = dynamic(import('@/components/search/map.js'), { ssr: false });

const Avatar = dynamic(import('@/core/avatar.js'));

const SpacePublicCartridge = dynamic(import('@/components/space/public/cartridge'));
const SpacePublicMobileCartridge = dynamic(import('@/components/space/public/mobileCartridge'));
const SpacePublicAmbiences = dynamic(import('@/components/space/public/static/ambiences'));
const SpacePublicStations = dynamic(import('@/components/space/public/static/stations'));
const SpacePublicReviews = dynamic(import('@/components/space/public/static/reviews'));
const SpacePublicDescription = dynamic(import('@/components/space/public/static/description'));
const SpacePublicGoogle = dynamic(import('@/components/space/public/static/google'));
const SpacePublicBookmark = dynamic(import('@/components/space/public/static/bookmark'));
const SpacePublicCovid = dynamic(import('@/components/space/public/static/covid'));
const SpacePublicHostServices = dynamic(import('@/components/space/public/byCategory/servicesHost'));
const SpacePublicCapacity = dynamic(import('@/components/space/public/byCategory/capacity'));
const SpacePublicCancelPolicy = dynamic(import('@/components/space/public/byCategory/cancelPolicy'));
const SpacePublicFormule = dynamic(import('@/components/space/public/byCategory/formule'));
const SpacePublicEquipments = dynamic(import('@/components/space/public/byCategory/equipments'));
const SpacePublicEnvironments = dynamic(import('@/components/space/public/byCategory/environments'));
const SpacePublicCalendar = dynamic(import('@/components/space/public/byCategory/calendar'));
const SpacePublicSimilarSpaces = dynamic(import('@/components/space/public/byCategory/similarSpaces'));
const SpacePublicPrimaryServices = dynamic(import('@/components/space/public/byCategory/primaryServices'));
const SpacePublicPartners = dynamic(import('@/components/space/public/static/partners'));
const SpacePublicInternal = dynamic(import('@/components/space/public/static/internal'));
const SpacePublicDistrict = dynamic(import('@/components/space/public/static/district'));
const SpacePublicTopPictures = dynamic(import('@/components/space/public/static/top_pictures'));

const LoginByEmail = dynamic(import('@/components/header/login/email'));
const LoginByGoogle = dynamic(import('@/components/header/login/google'));
const LoginByFB = dynamic(import('@/components/header/login/facebook'));
const LoginByLk = dynamic(import('@/components/header/login/linkedin'));

const Header = dynamic(import('@/components/header/index.js'));
const Footer = dynamic(import('@/core/footer'));

export {
  Avatar,
  Header,
  HeaderConfirm,
  HeaderCorpo,
  HeaderLoginCorpo,
  HeaderLogin,
  HeaderRegisterCompany,
  HeaderSignup,
  HeaderSignupStep2,
  Footer,
  PartnerCard,
  Select,
  SelectBlack,
  DropDown,
  SpaceCardSkinHome,
  SpaceCardSkinCities,
  SpaceCardSkinCorpo,
  Input,
  Search,
  YesNo,
  PartnerResume,
  BreadcrumCms,
  Button,
  HeaderBookmark,
  SpaceSimulator,
  HomeZonePlus,
  HomeZoneSpacesPartners,
  ActivitiesCard,
  ProfileCard,
  ParamsCard,
  TeamCard,
  LayoutCard,
  HomeZoneSpacesCities,
  LoginByEmail,
  LoginByGoogle,
  LoginByFB,
  LoginByLk,
  SearchRiders,
  SearchLoading,
  SearchMap,
  SpacePublicCartridge,
  SpacePublicMobileCartridge,
  SpacePublicAmbiences,
  SpacePublicStations,
  SpacePublicReviews,
  SpacePublicCapacity,
  SpacePublicPartners,
  SpacePublicInternal,
  SpacePublicDistrict,
  SpacePublicHostServices,
  SpacePublicCancelPolicy,
  SpacePublicFormule,
  SpacePublicEquipments,
  SpacePublicEnvironments,
  SpacePublicCalendar,
  SpacePublicDescription,
  SpacePublicGoogle,
  SpacePublicSimilarSpaces,
  SpacePublicBookmark,
  SpacePublicCovid,
  SpacePublicPrimaryServices,
  SpacePublicTopPictures,
};
